/**
 * Created by JAVIER on 10/31/2019.
 */
import React from 'react';
import { Modal, Input, Form } from 'antd';

class SharedLoginModal extends React.Component {

    constructor(props) {
        super(props)
    }

    render() {

        return (
            <Modal  visible={this.props.visible}
                    onOk={ () => {
                       this.props.onSubmit(this.username, this.password)
                        this.username = null;
                        this.password = null

                    }}
                    onCancel={() => {
                        this.props.onCancel();
                    }}
                    closable={false}
                    okText="Submit"
                    cancelText={''}
            >
                <Form id="formLogin" layout={'vertical'}  >
                    <Form.Item label="Username" name="username"
                               rules={[
                                   {
                                       required: true,
                                       message: `Please enter username`,
                                   },
                               ]}>
                        <Input placeholder="Username" onChange={ (e)=>{
                            this.username = e.target.value
                        }
                        }/>
                    </Form.Item>
                    <Form.Item label="Password" name="password"
                               rules={[
                                   {
                                       required: true,
                                       message: `Please enter password`,
                                   },
                               ]}>
                        <Input placeholder="Password" type="password" onChange={ (e)=>{
                            this.password = e.target.value
                        }
                        }/>
                    </Form.Item>
                </Form>
            </Modal>
        )
    }

}

export default SharedLoginModal;